import React, { Component } from "react";
// import { proofs } from "../../utils/documentList";
import UploadInput from "../../utils/createUploadInputs";
// import axios from "axios";
import { getApiData } from "../../api/api";
import { connect } from "react-redux";
import { showLoader } from "./../../redux/actions/action_loader";
import Error from "../Error/Error";
import LinearProgress from "@material-ui/core/LinearProgress";
// import { filter } from "lodash";
import AxiosRequest from "../../utils/axios";

const axios = new AxiosRequest().getClient()

class DocumentUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      uploadError: false,
      showLoader: false,
      uploading: false,
      text: "",
      errorMessage: "",
      enableSubmit: false,
      documentList: localStorage.getItem("documentList"),
    };
  }
  componentDidMount() {
    this.startLoad();
  }

  startLoad = () => {
    const documentListnew = JSON.parse(this.state.documentList);
    let newDocsArray = [];
    documentListnew.forEach((doc) => {
      doc.type = ".pdf, .png, .jpeg, .tif, .tiff";
      doc.documentByteArray = "";
      doc.label = doc.documentName;
      doc.uploadErrormsg = "";
      newDocsArray.push(doc);
    });
    console.log({ newDocsArray });
    this.setState({ documents: newDocsArray }, () =>
      this.validateSubmit(newDocsArray)
    );
  };

  validateSubmit = (docArray = this.state.documents) => {
    let validate = true;
    //////
    let arr1 = [];
    let arr2 = [];
    docArray.forEach((d) => {
      if (d.mandatory === "Y") {
        arr1.push(d);
      }
    });
    console.log("1", arr1);

    docArray.forEach((d) => {
      if (d.documentType === "FD") {
        arr2.push(d);
      }
    });
    console.log("2", arr2);

    // let FinancialDoc = docArray.filter(
    //   (d) => d.documentType === "FD" && d.documentUploaded === true
    // );
    // console.log("3", FinancialDoc);

    let MendatoryDoc = docArray.filter(
      (d) => d.mandatory === "Y" && d.documentUploaded === true
    );
    console.log("4", MendatoryDoc);

    if (arr1.length === 0 && arr2.length === 0) {
      this.setState({ enableSubmit: true });
    } else if (arr1.length !== 0 && arr2.length !== 0) {
      if (arr1.length === MendatoryDoc.length) {
        this.financialDocumentCheck(validate);
      } else {
        this.setState({ enableSubmit: false });
      }
    } else if (arr1.length !== 0 && arr2.length === 0) {
      if (arr1.length === MendatoryDoc.length) {
        this.setState({ enableSubmit: true });
      } else {
        this.setState({ enableSubmit: false });
      }
    } else if (arr1.length === 0 && arr2.length !== 0) {
      this.financialDocumentCheck(validate);
    }
  };

  financialDocumentCheck = (validate) => {
    console.log({ validate }, this.state.documents);
    let FinancialDoc = this.state.documents.filter(
      (d) => d.documentType === "FD" && d.documentUploaded === true
    );
    if (validate && FinancialDoc.length > 0) {
      this.setState({ enableSubmit: validate });
    } else {
      this.setState({ enableSubmit: false });
    }
  };

  handleSubmit = async (e) => {
    this.setState({ uploading: true, text: "Submitting..." });
    e.preventDefault();
    this.setState({ uploadError: false, errMsg: "" });
    console.log(this.state.documents);
    let docs = JSON.parse(JSON.stringify(this.state.documents));
    let newArray = docs.map((doc) => {
      delete doc.type;
      delete doc.label;
      delete doc.maxSize;
      delete doc.documentByteArray;
      return doc;
    });
    console.log(newArray);
    let { url, body } = getApiData("validateUploadLink");
    body.request.payload.action = "finalSubmit";

    body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");
    body.request.payload.submitRequestPayload.documentList = newArray;
    body.request.payload.uploadRequestPayload = null;

    console.log(body);
    try {
      const response = await axios.post(url, body);
      console.log(response);
      let {
        businessMsg,
      } = response.data.response.payload.submitResponsePayload;
      if (response && response.data.response.msgInfo.msgCode == 200) {
        console.log("Successfully submitted");
        this.props.history.push("/thankyou");
      } else {
        throw businessMsg;
      }
    } catch (err) {
      this.setState({ uploadError: true, errMsg: err });
    } finally {
      this.setState({ uploading: false, text: "" });
    }
  };

  handleClick = (index) => {
    const { documents } = this.state;
    const updatedDocuments = [...documents];
    updatedDocuments[index].uploadErrormsg = "";
    updatedDocuments[index].uploadSucessmsg = "";
    // console.log({ updatedDocuments, documents });
    // const docsArray = JSON.parse(JSON.stringify(this.state.documents));
    // docsArray.forEach((item) => {
    //   item.uploadErrormsg = "";
    //   item.uploadSucessmsg = "";
    // });
    this.setState({ documents: updatedDocuments });
  };

  handleChange = async (e) => {
    if (!window.navigator.onLine) {
      this.setState({
        verificationError: true,
        errMsg: "Please check you network connection",
      });
      return;
    }
    e.persist();
    try {
      this.setState({ uploading: true, text: "Uploading..." });
      let uploadError = false;
      let errMsg = "";
      let uploading = false;
      let text = "";

      let { name } = e.currentTarget;
      let { url, body } = getApiData("validateUploadLink");
      body.request.payload.posvRefNumber = localStorage.getItem(
        "posvRefNumber"
      );
      body.request.payload.action = "upload";

      let docsArray = this.state.documents.slice(
        0,
        this.state.documents.length
      );
      let itemIndex = docsArray.findIndex(
        (item, index) => item.documentName === name
      );
      let item = docsArray[itemIndex];
      let file = e.target.files[0];
      if (file) {
        let maxSize = 5048;

        if (/png|pdf|jpeg|tiff|tif|jpg/gi.test(file.type)) {
          maxSize = 5000000;
        }
        let fileextention = e.target.files[0].type.split("/")[1];
        body.request.payload.uploadRequestPayload.documentExtension = fileextention;
        let myReader = new FileReader();
        myReader.onloadend = async (event) => {
          if (!/png|pdf|jpeg|tiff|tif|jpg/gi.test(file.type)) {
            item.uploadErrormsg = "Please upload only the specified formats";
            item.documentUploaded = false;
          } else if (file.size > maxSize) {
            item.uploadErrormsg =
              "The uploaded document size should not be more than 5 MB";
            item.documentUploaded = false;
          } else if (file.size <= maxSize) {
            item.uploadErrormsg = undefined;
            item.documentByteArray = myReader.result;
            body.request.payload.uploadRequestPayload.documentName =
              item.documentName;
            body.request.payload.uploadRequestPayload.documentCode =
              item.documentCode;
            body.request.payload.uploadRequestPayload.documentByteArray = item.documentByteArray.split(
              ","
            )[1];
            console.log(item);
            const res = await axios.post(url, body);
            console.log(res);
            let {
              businessMsg,
            } = res.data.response.payload.uploadResponsePayload;
            console.log(businessMsg);

            let { msgCode } = res.data.response.msgInfo;
            console.log(msgCode);

            if (msgCode == 200) {
              item.documentUploaded = true;
              item.uploadSucessmsg = businessMsg;
              item.newDocumentUploaded = true;
            } else {
              item.documentUploaded = false;
              item.uploadErrormsg = businessMsg;
              item.newDocumentUploaded = false;
            }
          }
          docsArray[itemIndex] = item;
          let docsArraynew = docsArray.map((doc) => {
            delete doc.documentByteArray;
            return doc;
          });

          console.log("aaaa", docsArraynew);
          localStorage.setItem("documentList", JSON.stringify(docsArraynew));

          this.setState(
            { documents: docsArray, uploadError, errMsg, uploading, text },
            () => this.validateSubmit(docsArray)
          );
        };
        await myReader.readAsDataURL(file);
      } else {
        this.setState({ uploading: false });
      }
    } catch (err) {
      this.setState(
        {
          uploadError: err,
          errMsg: "There seems to be some technical issue",
          uploading: false,
          text: "",
        },
        () => this.validateSubmit()
      );
    }
  };

  render() {
    const { errorMessage, enableSubmit } = this.state;
    // console.log(this.state.documents);
    return (
      <>
        {/* {this.state.showLoader ? (
          <>
            <LinearProgress style={{ visibility: "visible" }} />
            <div className="display_text">Please wait...</div>
          </>
        ) : null} */}
        {this.state.uploading ? (
          <>
            <LinearProgress style={{ visibility: "visible" }} />
            <div className="uploading_text">{this.state.text}</div>
          </>
        ) : null}
        {this.state.documents.length > 0 && (
          <div className="main-container">
            <h1 className="heading">Upload Documents</h1>
            <form onSubmit={this.handleSubmit}>
              {this.state.documents.map((doc, index) => (
                <UploadInput
                  label={doc.label}
                  name={doc.documentName}
                  type={doc.type}
                  value={doc.documentByteArray}
                  index={index}
                  key={index}
                  onClick={this.handleClick}
                  onChange={this.handleChange}
                  documentUploaded={doc.documentUploaded}
                  size={doc.maxSize}
                  uploadErrmsg={doc.uploadErrormsg}
                  uploadSuccmsg={doc.uploadSucessmsg}
                />
              ))}
              {this.state.uploadError ? (
                <div className="err-msg">{this.state.errMsg}</div>
              ) : null}
              <div className="btn-cntnr">
                <button className="btn" disabled={!enableSubmit}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        )}
        {this.state.verificationError ? (
          <Error errorMsg={errorMessage} />
        ) : null}
      </>
    );
  }
}

export default connect(null, { showLoader })(DocumentUpload);
